module.exports = __webpack_public_path__ + "img/alert.06b4b586.svg";